<template>
  <div>
    <p class="sub-title"> IOS系统分布</p>
    <canvas id="container"></canvas>
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index-all";
export default {
  props: ['iosData'],
  data() {
    return {
      chart: null
    }
  },
  watch: {
    iosData() {
      if (this.iosData.length) {
        this.$nextTick(() => {
          this.drawPie();
        });
      }
    },
  },

  created() {
    // this.$nextTick(() => {
    //   if (this.iosData.length) {
    //     this.drawPie();
    //   }
    // })
  },
  methods: {
    drawPie() {
      let data = [{
        name: '其他消费',
        y: 6371664,
        const: 'const'
      }, {
        name: '生活用品',
        y: 7216301,
        const: 'const'
      }, {
        name: '通讯物流',
        y: 1500621,
        const: 'const'
      }, {
        name: '交通出行',
        y: 586622,
        const: 'const'
      }, {
        name: '饮食',
        y: 900000,
        const: 'const'
      }];
      // this.iosData.forEach(item => {
      //   item.const = 'const';
      //   item.versionName = 'V' + item.versionName;
      // })
      let iosData = this.iosData.slice(0).reverse();
      iosData.forEach(item => {
        item.const = 'const';
        item.name = 'V' + item.versionName;
        item.y = item.count;
      })
      let dd = iosData.slice(4);
      let ddItem = {
        const: 'const',
        name: dd[0] ? dd[0].name + '及以下' : '',
        y: dd.reduce((sum, item) => sum + item.count, 0),
        count: dd.reduce((sum, item) => sum + item.count, 0),
      }
      data = iosData.slice(0,4).concat([ddItem]);

      const chart = new F2.Chart({
        id: 'container',
        pixelRatio: window.devicePixelRatio
      });

      chart.source(data);
      chart.coord('polar', {
        transposed: true,
        radius: 0.75
      });
      chart.legend(false);
      chart.axis(false);
      chart.tooltip(false);

      // 添加饼图文本
      chart.pieLabel({
        sidePadding: 40,
        label1: function label1(data, color) {
          return {
            text: data.name,
            fill: color
          };
        },
        label2: function label2(data) {
          return {
            text: '' + String(Math.floor(data.count * 100) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            fill: '#808080',
            fontWeight: 'bold'
          };
        }
      });

      chart.interval()
        .position('const*count')
        .color('name', ['#1890FF', '#13C2C2', '#2FC25B', '#FACC14', '#F04864'])
        .adjust('stack');
      chart.render();
      this.chart = chart;
    }

  }
}
</script>

<style lang="scss" scoped>
#container{
  height: 230px;
  width: 100%;
}
.sub-title{
  color: #999;
}
</style>
